import { render, staticRenderFns } from "./VirtualCompanySelector.vue?vue&type=template&id=4799bb97"
import script from "./VirtualCompanySelector.vue?vue&type=script&lang=js"
export * from "./VirtualCompanySelector.vue?vue&type=script&lang=js"
import style0 from "./VirtualCompanySelector.vue?vue&type=style&index=0&id=4799bb97&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports